import { render, staticRenderFns } from "./CardClient.vue?vue&type=template&id=058c38f8&scoped=true&"
import script from "./CardClient.vue?vue&type=script&lang=js&"
export * from "./CardClient.vue?vue&type=script&lang=js&"
import style0 from "./CardClient.vue?vue&type=style&index=0&id=058c38f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058c38f8",
  null
  
)

export default component.exports